import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const STORAGE_KEY = 'merchant_last_routes';

const MerchantRouteWatcher = () => {
    const location = useLocation();

    useEffect(() => {
        const pathname = location.pathname;
        const parts = pathname.split('/').filter(Boolean);
        const merchantCode = parts[0];

        if (!merchantCode) return;

        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            const routes = stored ? JSON.parse(stored) : {};

            routes[merchantCode] = pathname;

            localStorage.setItem(STORAGE_KEY, JSON.stringify(routes));
        } catch (error) {
            console.error('Failed saving merchant route:', error);
        }
    }, [location.pathname]);

    return null;
};

export default MerchantRouteWatcher;